export { Avatar, type AvatarProps } from "./Avatar.component";
